module.exports = __webpack_public_path__ + "static/media/S4N5-3.89829226.svg";